import axios from 'axios';
import { store } from '../index';
import { navigateAway } from '../../utils/nav';
import { updateLegacySessionKey } from '../actions';
import { useHistory } from 'react-router';
import SETTINGS from '../../settings';
import { setAccessToken, setRefreshToken } from '../actions';

const ax = axios.create({
  baseURL: SETTINGS.baseAPIUrl,
});

// add the header to the request
ax.interceptors.request.use(
  (config) => {
    //add the token;
    const state = store.getState();
    const accessToken = state.session.accessToken;
    // console.log("ACCESS CHECK", accessToken, state.session)
    // console.log("REFRESH CHECK", state.session.refreshToken)
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken;
    }

    const campaign = state.session.focusedCampaign.id;
    //campaign param on every outgoing call.
    if (!config.params) config.params = {};
    config.params = { ...config.params, campaign };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ax.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    if (!error.response) return Promise.reject(error);

    if ([401, 400].includes(error.response.status) && originalRequest.url.includes('/auth/token')) {
      // window.location = '/login';
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const state = store.getState();
      const refreshToken = state.session.refreshToken;
      return ax
        .post('/auth/token/refresh/', {
          refresh: refreshToken,
        })
        .then((res) => {
          if (res.status === 200) {
            const newAccessToken = res.data.access;
            store.dispatch(setAccessToken(newAccessToken));
            ax.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;

            console.log(originalRequest);
            return ax(originalRequest);
          }
        });
    }

    // if (error.response.status === 403) {
    //   return (window.location.href = '/accessdenied');
    // }
    return Promise.reject(error);
  }
);

export default {
  get(url, params) {
    return ax
      .get(url, { params })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  post(url, request) {
    return ax
      .post(url, { ...request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  patch(url, request) {
    return ax
      .patch(url, { ...request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  delete(url, request) {
    return ax
      .delete(url)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
};
